<template>
  <div v-if="isAdministrator">
    <div class="bs-header">
      <span
        class="bs-Htitle"
      >管理后台</span>
    </div>
    <div class="bs-container">
      <div class="bs-side">
        <a-menu
          mode="inline"
          :default-selected-keys="selectedKey"
          :selected-keys="selectedKey"
          :default-open-keys="openKeys"
        >
          <a-sub-menu key="1">
            <span slot="title">钉钉消息</span>
            <a-menu-item key="Message">
              <router-link to="/backstage/message">
                发送消息
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="2">
            <span slot="title">入口设置</span>
            <a-menu-item key="SwitchSet">
              <router-link to="/backstage/switchSet">
                开关设置
              </router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="3">
            <span slot="title">权限设置</span>
            <a-menu-item key="AdminPermissions">
              <router-link to="/backstage/adminPermissions">
                管理员权限
              </router-link>
            </a-menu-item>
            <a-menu-item key="SysPermissions">
              <router-link to="/backstage/sysPermissions">
                系统角色权限
              </router-link>
            </a-menu-item>
            <a-menu-item key="BpPermissions">
              <router-link to="/backstage/bpPermissions">
                绩效BP权限
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="bs-right">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Menu } from 'ant-design-vue'

Vue.use(Menu)

export default {
  name: 'BsFramework',
  data() {
    return {
      selectedKey: ['Message'],
      openKeys: ['1', '2', '3'],
      isAdministrator: false,
    }
  },
  computed: {
    href: {
      get() {
        return this.$route.path
      },
    },
  },
  // 监听浏览器URL地址变化，自动切换当前munu
  watch: {
    href() {
      this.fetchMenu()
    },
  },
  async created() {
    // 判断用户身份，如果不是管理员，返回系统首页
    const result = await this.$api.user.getUserInfo()
    if (result.sysRole === 'admin') {
      this.isAdministrator = true
      this.fetchMenu()
    } else {
      this.$router.replace({ name: 'MyOKR' })
    }
  },
  methods: {
    // 根据路由地址设定当前menu默认值 href 是string类型
    fetchMenu() {
      const arr = []
      switch (this.href) {
        case '/backstage/message':
          arr.push('Message')
          break
        case '/backstage/switchSet':
          arr.push('SwitchSet')
          break
        case '/backstage/adminPermissions':
          arr.push('AdminPermissions')
          break
        case '/backstage/sysPermissions':
          arr.push('SysPermissions')
          break
        case '/backstage/bpPermissions':
          arr.push('BpPermissions')
          break
      }
      this.$set(this, 'selectedKey', arr)
      //   console.log("get", this.defaultKey);
    },
  },
}
</script>

<style lang="less" scoped>
.bs-header{position: relative;}
.bs-Htitle{position: absolute; top:-74px; left:190px; z-index: 2; font-size: 20px; font-weight: 100; color:#fff;}
.bs-container{display: flex; padding: 14px 0 40px;}
.bs-side{width:200px; height: 500px; margin-right: 16px; padding: 24px 0; background: #fff; border-radius: 4px;}
.bs-right{flex: 1; width:664px; background: #fff;}
.ant-menu-inline{border-right: none;}
.ant-menu-submenu-title{font-weight: bold;}
</style>
